import { injectable } from 'tsyringe';
import { BaseViewModel } from '@/shared/viewmodels/BaseViewModel';
import { BillingService, type BillingOverview } from './BillingService';

@injectable()
export class BillingViewModel extends BaseViewModel {
    overview: BillingOverview | null = null;
    loading = false;
    savingCard = false;
    error: string | null = null;

    constructor(private readonly service: BillingService) {
        super();
    }

    async load(): Promise<void> {
        this.loading = true;
        this.error = null;
        this.notifyChange();
        try {
            this.overview = await this.service.getOverview();
        } catch (e) {
            this.error = e instanceof Error ? e.message : 'Failed to load billing';
        } finally {
            this.loading = false;
            this.notifyChange();
        }
    }

    createSetupIntent(): Promise<{ clientSecret: string; customerId: string }> {
        return this.service.createSetupIntent();
    }

    openInvoice(invoiceId: string): Promise<void> {
        return this.service.openInvoicePdf(invoiceId);
    }

    /** Save the confirmed card, then refresh the overview. */
    async saveCard(paymentMethodId: string): Promise<void> {
        this.savingCard = true;
        this.notifyChange();
        try {
            await this.service.confirmCard(paymentMethodId);
            await this.load();
        } finally {
            this.savingCard = false;
            this.notifyChange();
        }
    }
}
